<template>
  <div
    class="base-content-card kds-main-wrapper"
    :data-qa="dataQa"
  >
    <div class="kds-content-block">
      <p class="kds-typography-title-xlarge">{{ title }}</p>
      <slot name="description">
        <p class="kds-typography-paragraph-large">{{ description }}</p>
      </slot>
    </div>
    <slot name="content" />
    <!--
      Illustration slot behavior:
      - Slotted elements are forced to width: 100% with max-width: 448px.
      - Slotted <img> and <svg> are rendered as block elements at width: 100%, height: auto.
      Use one root node in this slot (e.g. an inline SVG wrapper or an <img>).
    -->
    <div class="base-content-card__illustration">
      <slot name="illustration" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  dataQa: {
    type: String,
    default: '',
  },
})
</script>

<style lang="scss">
@use 'sass:map';

.base-content-card {
  color: $kds-color-text-primary;
  border-radius: $kds-space-2x;
  padding: $kds-space-3x $kds-space-3x 0;
  overflow: hidden;
  display: grid;
  gap: $kds-space-3x;

  &__illustration {
    display: flex;
    justify-content: center;
    margin-inline: calc(-1 * $kds-space-3x);

    > * {
      display: block;
      width: 100%;
      max-width: 448px;
    }

    img {
      display: block;
      width: 100%;
      height: auto;
    }

    svg {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}
</style>
